import { GetterTree } from 'vuex';
import { State } from './state';
import { RootState } from '@/store/index';

const getters: GetterTree<State, RootState> = {
};

export default getters;
